import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_PDF_API_BASE_URL,
})

export function renderPDF(html, name) {
  return instance
    .post(
      `direct`,
      {
        apikey: process.env.VUE_APP_PDF_API_KEY,
        html,
        name,
      },
      {
        responseType: 'blob',
      }
    )
    .then((r) => r.data)
}
